import type { CompanyFilters } from "../../types";
import {
  normalizeNumberArray,
  normalizeStringArray,
} from "../../utils/normalize";
import { inferIndustryType, type IndustrySlice } from "./slice";

export function toCompanyFilters(
  slice: IndustrySlice
): Partial<CompanyFilters> {
  const industryFilter: NonNullable<CompanyFilters["industry"]> = {};

  if (slice.industryIds.length > 0) {
    industryFilter.industryIds = slice.industryIds;
  }
  if (slice.sicIds.length > 0) {
    industryFilter.sicUs1987Ids = slice.sicIds;
  }
  if (slice.naicsIds.length > 0) {
    industryFilter.naics2012Ids = slice.naicsIds;
  }
  if (slice.excludedIds.length > 0) {
    industryFilter.excludedIndustryIds = slice.excludedIds;
  }
  if (slice.excludedSicIds.length > 0) {
    industryFilter.excludedSicUs1987Ids = slice.excludedSicIds;
  }
  if (slice.excludedNaicsIds.length > 0) {
    industryFilter.excludedNaics2012Ids = slice.excludedNaicsIds;
  }

  return Object.keys(industryFilter).length > 0
    ? { industry: industryFilter }
    : {};
}

export function fromCompanyFilters(filters: CompanyFilters): IndustrySlice {
  const { industry } = filters;

  const industryIds = normalizeNumberArray(industry?.industryIds);
  const sicIds = normalizeStringArray(industry?.sicUs1987Ids).map(String);
  const naicsIds = normalizeStringArray(industry?.naics2012Ids).map(String);
  const excludedIds = normalizeNumberArray(industry?.excludedIndustryIds);
  const excludedSicIds = normalizeStringArray(
    industry?.excludedSicUs1987Ids
  ).map(String);
  const excludedNaicsIds = normalizeStringArray(
    industry?.excludedNaics2012Ids
  ).map(String);

  const base: IndustrySlice = {
    industryIds,
    sicIds,
    naicsIds,
    excludedIds,
    excludedSicIds,
    excludedNaicsIds,
  };

  return {
    ...base,
    selectedIndustryType: inferIndustryType(base),
  };
}
